import script from "./card-loading.vue?vue&type=script&setup=true&lang=js"
export * from "./card-loading.vue?vue&type=script&setup=true&lang=js"

import "./card-loading.vue?vue&type=style&index=0&id=e923d08e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e923d08e"]])

export default __exports__